import { ArrowUpIcon } from "@heroicons/react/outline";
import { useRef, useState } from "react";
import { Button } from "./Buttons";
import { API_URL } from "lib/API";
import { collect, store } from "react-recollect";

function FileUploadButton({
  children = (
    <>
      <ArrowUpIcon className="mr-2 size-6" />
      select a file&hellip;
    </>
  ),
  className = "btn-secondary w-48",
  onUploadComplete,
  acceptedFileTypes,
  allowMultipleFiles,
  onUploadStart,
}) {
  const fileInputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const onChange = async (e) => {
    if (!e.target?.files?.length) return;

    setUploading(true);
    onUploadStart && onUploadStart();

    const formData = new FormData();
    const f = e.target.files[0];
    formData.append("file", f, f.name);
    // Array.from(e.target.files).forEach((f) => {
    //   console.log("adding", e.target.name, f);
    //   formData.append(e.target.name, f);
    // });
    // console.log(formData, e.target.files[0]);
    const r = await fetch(API_URL + "uploadfile", {
      method: "POST",
      headers: {
        Authorization: store.token,
      },
      body: formData,
    }).then((r) =>
      !r.ok ? console.error(`Error while uploading files!`) : r.json(),
    );

    if (r?.success) {
      onUploadComplete && onUploadComplete(r);
      setUploading(false);
    } else {
      console.error(`Error while uploading file`);
    }
  };

  // return a nice button that we can style
  // (also gets rid of the "no file chosen" text)
  return (
    <>
      <Button
        onClick={() => fileInputRef.current?.click()}
        className={className}
      >
        {uploading ? "..." : children}
      </Button>
      <input
        accept={acceptedFileTypes}
        multiple={allowMultipleFiles}
        name="file"
        onChange={onChange}
        ref={fileInputRef}
        className="hidden"
        type="file"
      />
    </>
  );
}
export default collect(FileUploadButton);
